import axios from "axios";

import { env } from "../config/env";

export const api = axios.create({
  baseURL: env.apiUrl,
  timeout: 15_000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json"
  }
});
